import { PPSlotBooking } from "@/picking-portal/models/PPSlotBooking";
import { DateTime } from "luxon";
import { httpService } from "@/common/services/HttpService";
import { PPBookings } from "@/picking-portal/models/PPBookings";

class PPBookingService {
  async get(storeId: string, bookingId: number): Promise<PPSlotBooking> {
    const { data } = await httpService
      .getInstance()
      .get<PPSlotBooking>(`/api/v1/backoffice/staff/stores/${storeId}/bookings/${bookingId}`);
    return data;
  }

  async getBookingsByDate(storeId: string, date: DateTime): Promise<PPBookings[]> {
    const from = date.startOf("day").toISO();
    const to = date.endOf("day").toISO();
    const { data } = await httpService
      .getInstance()
      .get<PPBookings[]>(`/api/v1/backoffice/staff/stores/${storeId}/bookings`, {
        params: {
          from: from,
          to: to,
        },
      });
    return data;
  }

  async getBookingsByTimeInterval(storeId: string, from: DateTime, to: DateTime): Promise<PPBookings[]> {
    const { data } = await httpService
      .getInstance()
      .get<PPBookings[]>(`/api/v1/backoffice/staff/stores/${storeId}/bookings`, {
        params: {
          from: from.toISO(),
          to: to.toISO(),
        },
      });
    return data;
  }
}

export const bookingService = new PPBookingService();
